export enum EndType {
  LEAVE_PAGE = 'Leave Page',
  CLOSE_BROWSER = 'Close Browser',
  END_VIDEO = 'End Video',
  CLOSE_POPUP = 'Close Popup',
}
